export const defaultState = {
  systemUsers: [],
  degrees: [],
  specializations: [],
  teacherProfile: {},
  profileDocumentTypes: [],
  profileDocuments: [],
  schoolLeadersEvaluations: [],
};
